import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { makeStyles } from '../../../tools/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#0F7B85',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#0B4E54',
    },
  },
}));

function StyledButton({ children, ariaLabel, ...props }) {
  const classes = useStyles();
  return (
    <Button aria-label={ariaLabel || 'styled-button'} className={classes.root} {...props}>
      {children}
    </Button>
  );
}

StyledButton.propTypes = {
  children: PropTypes.node,
  props: PropTypes.object,
};

export default StyledButton;
